import React from 'react';

export default function LoadingOverlay({ open, title = 'Loading…', lines = [], spinnerColor = 'text-red-600' }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[200] bg-white/80 backdrop-blur-sm flex items-center justify-center" role="dialog" aria-modal="true" aria-busy="true">
      <div className="bg-white border border-zinc-200 rounded-2xl shadow-2xl p-8 w-full max-w-md text-center">
        <div className="relative mx-auto mb-6">
          <div className="relative h-16 w-16 mx-auto">
            <div className="absolute inset-0 rounded-full border-4 border-zinc-200" />
            <div className={`absolute inset-0 rounded-full border-4 ${spinnerColor} border-t-transparent animate-spin`} />
            <div className="absolute inset-2 rounded-full border-4 border-zinc-100 border-b-transparent animate-spin [animation-duration:2.2s]" />
          </div>
        </div>
        <div className="text-lg font-semibold text-zinc-900">{title}</div>
        {Array.isArray(lines) && lines.length > 0 && (
          <div className="mt-3 space-y-1 text-sm text-zinc-700">
            {lines.map((l, idx) => (
              <div key={idx} className="animate-pulse" style={{ animationDelay: `${idx * 180}ms` }}>{l}</div>
            ))}
          </div>
        )}
        <div className="mt-4 text-[11px] text-zinc-500">This may take a few seconds. Thanks for your patience.</div>
      </div>
    </div>
  );
}
